import { IResourceComponentsProps, useExport, useList } from '@pankod/refine-core'

import {
  List,
  RefreshButton,
  CreateButton,
  ExportButton,
  Table,
  Space,
  EditButton,
  DeleteButton,
  DateField,
  getDefaultSortOrder,
  useModalForm,
  Icons,
  Tag,
  Input,
  Divider,
  Button,
  useTable,
  Form
} from '@pankod/refine-antd'
// import { useTable } from '@pankod/refine-core'

import { IGrade } from 'interfaces'
import { CreateGrade } from './create'
import { EditGrade } from './edit'
import { useState } from 'react'
import { exportToExcel } from 'exportToExcel'
const { PlusOutlined } = Icons

export const GradesList: React.FC<IResourceComponentsProps> = () => {
  const [fil,setHasPagination]=useState<any>(true)
  const [currentPage,setCurrentPage]=useState<number>(1)
  const { data: testTrackListData } = useList({ resource: 'test_tracks', metaData: { fields: ['id', 'grade_ids'] } })
  const { tableProps,searchFormProps, sorter, tableQueryResult ,setFilters,filters} = useTable<IGrade>({
    // hasPagination:pagination,
 
    
    initialSorter: [
      {
        field: 'created_at',
        order: 'desc',
      },
    ],
 
    metaData: {
      fields: ['id', 'name', 'created_at', { grade_levels: ['name'] }, { questions_ids: ['id'] }, { work_requests_ids: ['id'] }],
    },
    onSearch: (values:any) => {
      return [
          {
            field: "name",
            operator: "eq",
            value: parseInt(values?.title)
          },
      ];
  },
  })
  const { tableQueryResult:exportData} = useTable<IGrade>({
    hasPagination:false,
    
    initialSorter: [
      {
        field: 'created_at',
        order: 'desc',
      },
    ],
    metaData: {
      fields: ['id', 'name', 'created_at', { grade_levels: ['name'] }, { questions_ids: ['id'] }, { work_requests_ids: ['id'] }],
    },
  })
  const { formProps, modalProps, show } = useModalForm({
    resource: 'grades',
    action: 'create',
  })
  const {
    formProps: editFormProps,
    modalProps: editModalProps,
    show: editShow,
  } = useModalForm({
    resource: 'grades',
    action: 'edit',
    metaData: {
      fields: ['id', 'name', 'grade_levels_id', 'created_at'],
    },
  })

  // const { triggerExport, isLoading } = useExport<IGrade>()

  const hideDeleteButton = (record: IGrade): boolean => {
    const { work_requests_ids: wrIds, questions_ids: qIds } = record
    if (wrIds !== undefined && qIds !== undefined) {
      const shouldHide = wrIds.length > 0 || qIds.length > 0
      return shouldHide
    }
    if (testTrackListData?.data !== undefined) {
      let shouldHide = false
      testTrackListData.data.map(eachTestTrack => {
        eachTestTrack.grade_ids.map((gradeId: string) => {
          if (record.id === gradeId) {
            shouldHide = true
          }
        })
      })
      return shouldHide
    }
    return false
  }

  const triggerExport=()=>{
    let data:object[]=[]
    if(exportData?.data?.data !==undefined){
      exportData?.data?.data?.forEach((item:IGrade)=>{
  data?.push({
    id:item?.id,
    name:item?.name,
    grade_levels:item?.grade_levels?.name,
    created_at:item?.created_at


  })
})
    }
    console.log({data});
    exportToExcel(data,`Grades_${Math.round(new Date().getTime() / 1000)}.xlsx`)
  }
  const resetSearch=()=>{
   
    tableQueryResult?.refetch()
  }
  return (
    <List
      pageHeaderProps={{
        extra: [
          //  <ExportButton onClick={triggerExport} loading={isLoading} />,
          <RefreshButton onClick={() => tableQueryResult?.refetch()} />,
          <CreateButton type="primary" icon={<PlusOutlined />} onClick={() => show()} />,
          <Button onClick={triggerExport}>Export</Button>
        ],
      }}
    >
                        
                        <Form {...searchFormProps}>
        <Space>
            <Form.Item name="title">
                <Input placeholder="Search by title" allowClear  onChange={(e)=>{
                            if(e.type==='click'){
                              setFilters([{
                                field: "name",
                                operator: "eq",
                                value:undefined
                              }])
resetSearch()
                            
                            }}}/>
            </Form.Item>
            <Button icon={<Icons.SearchOutlined/>} onClick={searchFormProps.form?.submit} >Search</Button>
        </Space>
    </Form>                   
                             
    <Divider/>
    <Table {...tableProps} >
        <Table.Column dataIndex="name" title="Name" />
        {/* <Table.Column<IGrade>
            dataIndex="medium_id"
            title="Medium"
            render={(_, record) => record?.medium?.name}
          /> */}

        <Table.Column<IGrade> dataIndex="grade_levels_id" title="Grade Level" render={(_, record) => record?.grade_levels?.name} />

        <Table.Column
          dataIndex="created_at"
          title="Created At"
          render={value => <DateField value={value} format="LLL" />}
          defaultSortOrder={getDefaultSortOrder('created_at', sorter)}
          sorter
        />
        <Table.Column<IGrade>
          title="Actions"
          dataIndex="actions"
          render={(_, record) => (
            <Space>
              <EditButton size="small" type="link" icon={null} recordItemId={record.id} onClick={() => editShow(record.id)} />
              <DeleteButton size="small" type="link" icon={null} recordItemId={record.id} hidden={hideDeleteButton(record)} />
            </Space>
          )}
        />
      </Table>
      <CreateGrade modalProps={modalProps} formProps={formProps} />
      <EditGrade modalProps={editModalProps} formProps={editFormProps} />
    </List>
  )
}
